import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs';

import { UserBill } from 'modules/shared/models/billable.models';

import { environment } from 'environment/environment';

@Injectable({
  providedIn: 'root'
})
export class BillableService {

  /**
   * Environment variable
   */
  private apiBase: string = environment.API_BASE;

  constructor(private httpClient: HttpClient) { }

  getUserBillableInfo(): Observable<UserBill> {
    return this.httpClient.get<UserBill>(`${this.apiBase}/api/billable/`);
  }
}
